'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _iconAliases = require('icons/iconAliases');

var _iconAliases2 = _interopRequireDefault(_iconAliases);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _memoize = require('react-utils/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _IconConstants = require('./IconConstants');

var _iconName = require('../utils/propTypes/iconName');

var _memoizeOne = require('react-utils/memoizeOne');

var _memoizeOne2 = _interopRequireDefault(_memoizeOne);

var _Timers = require('../utils/Timers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizeToRes = function sizeToRes(size) {
  return size <= _IconConstants.ICON_SIZES.small ? 'low' : 'high';
};

var getIconClassName = function getIconClassName(size, measuredRes) {
  var res = size != null ? sizeToRes(_IconConstants.ICON_SIZES[size] || size) : measuredRes;
  return 'private-icon__' + res;
};

var getComputedFontSize = function getComputedFontSize(size) {
  if (!size) return null;

  if (_IconConstants.ICON_SIZES.hasOwnProperty(size)) {
    return _IconConstants.ICON_SIZES[size];
  }

  return size;
};

var getStyle = function getStyle(style, color, size) {
  return _extends({
    color: color
  }, style, {
    fontSize: getComputedFontSize(size)
  });
};

var IconContent = _styledComponents2.default.span.withConfig({
  displayName: 'UIIcon__IconContent'
})(['font:inherit !important;&::before{content:"', '";}'], function (_ref) {
  var ligature = _ref.ligature;
  return ligature;
});

var getIconContent = (0, _memoize2.default)(function (ligature) {
  return _react2.default.createElement(IconContent, { 'aria-hidden': true, ligature: ligature });
});

var UIIcon = function (_PureComponent) {
  _inherits(UIIcon, _PureComponent);

  function UIIcon(props) {
    _classCallCheck(this, UIIcon);

    var _this = _possibleConstructorReturn(this, (UIIcon.__proto__ || Object.getPrototypeOf(UIIcon)).call(this, props));

    _this.state = {
      // Perf: Most icons are low-res, so this default minimizes state changes from measureSize()
      measuredRes: 'low'
    };
    _this._getStyle = (0, _memoizeOne2.default)(getStyle);
    _this.measureSize = _this.measureSize.bind(_this);
    _this.refCallback = _this.refCallback.bind(_this);
    return _this;
  }

  _createClass(UIIcon, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.delayedMeasureSize();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // ⚠️ This condition prevents infinite loops! ⚠️
      if (prevState.measuredRes === this.state.measuredRes) {
        this.delayedMeasureSize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _Timers.cancelSchedulerCallback)(this._timeout);
    }
  }, {
    key: 'delayedMeasureSize',
    value: function delayedMeasureSize() {
      (0, _Timers.cancelSchedulerCallback)(this._timeout); // Ensure only one callback is queued at a time
      this._timeout = (0, _Timers.requestSchedulerCallback)(this.measureSize);
    }

    /**
     * Measure the `fontSize` in the DOM to determine whether this should be a high-res or low-res
     * icon. Note that the measurement is skipped when the `size` prop is set.
     */

  }, {
    key: 'measureSize',
    value: function measureSize() {
      if (!this._el || this.props.size) return;
      var styles = window.getComputedStyle(this._el, null);
      if (styles == null) {
        // See #4208
        return;
      }
      var measuredSize = parseInt(styles.fontSize, 10);
      var measuredRes = sizeToRes(measuredSize);
      if (measuredRes !== this.state.measuredRes) {
        this.setState({
          measuredRes: measuredRes
        });
      }
    }
  }, {
    key: 'refCallback',
    value: function refCallback(ref) {
      this._el = ref;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          color = _props.color,
          className = _props.className,
          name = _props.name,
          screenReaderText = _props.screenReaderText,
          style = _props.style,
          size = _props.size,
          rest = _objectWithoutProperties(_props, ['color', 'className', 'name', 'screenReaderText', 'style', 'size']);

      var measuredRes = this.state.measuredRes;


      if (_iconAliases2.default[name]) {
        _devLogger2.default.warn({
          message: 'UIIcon: "' + name + '" is a deprecated alias. Please use the canonical icon name.',
          key: 'UIIcon-' + name,
          url: 'https://tools.hubteamqa.com/ui-library/styles/icons'
        });
      }

      var computedName = _iconAliases2.default[name] || name;
      var computedClassName = (0, _classNames2.default)('private-icon', getIconClassName(size, measuredRes), className);

      return _react2.default.createElement(
        'span',
        _extends({}, rest, {
          className: computedClassName,
          'data-icon-name': computedName,
          ref: this.refCallback,
          style: this._getStyle(style, color, size)
        }),
        getIconContent(computedName),
        screenReaderText ?
        // Spaces around screenReaderText prevents collisions withsiblingtext.
        _react2.default.createElement(
          'span',
          { className: 'sr-only' },
          ' ',
          screenReaderText,
          ' '
        ) : undefined
      );
    }
  }]);

  return UIIcon;
}(_react.PureComponent);

exports.default = UIIcon;


UIIcon.propTypes = {
  color: _react.PropTypes.string,
  name: (0, _iconName.getIconNamePropType)().isRequired,
  screenReaderText: _react.PropTypes.string,
  size: _react.PropTypes.oneOfType([_react.PropTypes.oneOf(Object.keys(_IconConstants.ICON_SIZES)), _react.PropTypes.number])
};

UIIcon.displayName = 'UIIcon';
module.exports = exports['default'];